module.exports = "/static/assets/587792406979ef550c011ea90a7cd566.svg";